<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Title"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_WORK_TITLE')"
                        :withMargin="false"
                        rules="required"
                        :alvqa="alvqa + '-textfield-title'"
                    />
                </v-col>
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Type"
                        :items="alternativeTitlesTypeDropdownItems" 
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_TYPE')"
                        :selection="true"
                        rules="required"
                        :withMargin="false"
                        :clearable="false"
                        :alvqa="alvqa + '-dropdown-type'"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import { DropdownPublishingWorksAlternativeTitleTypes } from '@/assets/dropdowns/alvDropdowns.js'

import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

export default {
    name: "AlternativeTitlesEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageTextField,
        BaseEditPageDropdown
    },
    data() {
        return {
            context: "WorksAlternativeTitles",
            alvqa: "publishing-works-edit-form-alternative-titles-panel-editing-dialog"
        }
    },
    computed: {
        alternativeTitlesTypeDropdownItems() { return DropdownPublishingWorksAlternativeTitleTypes },
    }
}
</script>